import type {Schedule} from '../types/domain'
import {scheduleNumericErrors} from './scheduleNumericErrors'

export function breakPlacementErrors(schedule: Schedule) {
  const counts = new Map<number, number>()
  for (const {afterLevelNumber} of schedule.breaks) counts.set(afterLevelNumber, (counts.get(afterLevelNumber) ?? 0) + 1)
  return schedule.breaks.map(({afterLevelNumber}) => {
    if (!Number.isInteger(afterLevelNumber) || afterLevelNumber < 1 || afterLevelNumber >= schedule.blinds.length) {
      return 'Choose an existing non-final blind level.'
    }
    if (counts.get(afterLevelNumber)! > 1) return 'Only one break may follow each blind level.'
    return undefined
  })
}

export function scheduleErrors(schedule: Schedule) {
  const numeric = scheduleNumericErrors(schedule)
  const placements = breakPlacementErrors(schedule)
  const breaks = placements.map((afterLevelNumber, index) => ({...numeric.breaks?.[index], afterLevelNumber}))
  return {...numeric, breaks: breaks.some(row => Object.values(row).some(Boolean)) ? breaks : undefined}
}

export const hasScheduleErrors = (schedule: Schedule) => Object.values(scheduleErrors(schedule)).some(Boolean)
export const scheduleWithOrderedBreaks = (schedule: Schedule): Schedule => ({...schedule, breaks: [...schedule.breaks].sort((a, b) => a.afterLevelNumber - b.afterLevelNumber)})
